import dayjs from "dayjs";

var formatDateIntervention = function(date) {
  let monthValue = date.toLocaleString("default", { month: "long" });
  let hoursValue = date.getHours();
  let minutesValue = date.getMinutes();

  if (dayjs(date).diff(dayjs(), "day") <= 1) {
    return (
      "de demain à " +
      +("0" + hoursValue).slice(-2) +
      "h" +
      (minutesValue > 0 ? ("0" + minutesValue).slice(-2) : "")
    );
  } else {
    return (
      "du " +
      date.getDate() +
      " " +
      monthValue +
      " à " +
      ("0" + hoursValue).slice(-2) +
      "h" +
      (minutesValue > 0 ? ("0" + minutesValue).slice(-2) : "")
    );
  }
};

export default formatDateIntervention;
